export default [
  {
    question: `What do I need to know?`,
    answer: `Staking via Unagii delegates to the Stakewithus validator to help secure the network and receive a share of incentivized rewards earned. Rewards are earned by staking tokens and are paid out on a per block basis. Users can withdraw or compound at any time.`,
  },
  {
    question: `How do I earn rewards with ARCH?`,
    answer: `Simply connect your wallet and stake your ARCH. The rewards are paid out on a per block basis. You can choose to withdraw your rewards back to your wallet or compound the rewards.`,
  },
  {
    question: `Where does the rewards come from?`,
    answer: `The ARCH token inflates at 10% a year. 25% of the inflation is directed towards Developer Inflation Tokens to reward developers who contracts are utilized on-chain. For more information on the economics behind Archway, please visit <a href="https://archway.io/assets/archway-economics.pdf" target="_blank" rel="noopener noreferrer">here</a>.`,
  },
  {
    question: `Is there a lock-up period?`,
    answer: `There is a 21 days unbonding period when you want to unstake your ARCH from the network. During this period. you earn 0 rewards and will still be suspecitble to slashing.`,
  },
  {
    question: `Are there any risks involved with staking ARCH on Unagii?`,
    answer: `Your ARCH will be staked to StakeWith.Us, a Singapore government backed staking infrastructure provider. There are slashing risks involved for downtime and double signing. Read about StakeWith.Us.`,
  },
  {
    question: `Where can I view governance proposals for Archway? How does voting work?`,
    answer: `You can view governance proposals by clicking on the Governance tab. In the event you do not vote, your vote will follow the choices of your validator, which in this case, is StakeWith.Us.`,
  },
];
